import { SvgIcon, SvgIconProps } from './SvgIcon';

export const RejectIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 10C16.5 13.5899 13.5899 16.5 10 16.5C8.47531 16.5 7.07323 15.975 5.96465 15.096L15.096 5.96465C15.975 7.07323 16.5 8.47531 16.5 10ZM4.90399 14.0353L14.0353 4.90399C12.9268 4.02496 11.5247 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 11.5247 4.02496 12.9268 4.90399 14.0353ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
